import { Role } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FetchStateType, getFetchStateChange } from "../../models";

interface IRoleData {
	all?: Role[];
	searchTerm: string;
	displayData?: Role[];
	displayedRole?: Role;
	fetchState: FetchStateType;
}

const initialState: IRoleData = {
	searchTerm: "",
	fetchState: { type: "not-started" },
};

const name = "roles";

const roleSlice = createSlice({
	name,
	initialState,
	reducers: {
		setData: (state, action: PayloadAction<Role[] | undefined>) => ({
			...state,
			all: action.payload,
			displayData: filterData(action.payload, state.searchTerm),
		}),
		setSearchTerm: (state, action: PayloadAction<string>) => ({
			...state,
			searchTerm: action.payload.toLocaleLowerCase(),
			displayData: filterData(state.all, action.payload),
		}),
		setDisplayed: (state, action: PayloadAction<Role | undefined>) => ({
			...state,
			displayedRole: action.payload,
		}),
		setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			displayedRole: action.payload.type === "successful" ? undefined : state.displayedRole,
			all: action.payload.type === "successful" ? undefined : state.all,
			displayData: action.payload.type === "successful" ? undefined : state.displayData,
			fetchState: getFetchStateChange(state.fetchState, action.payload),
		}),
	},
});

const filterData = (data?: Role[], searchTerm?: string) =>
	searchTerm === undefined || searchTerm === ""
		? data
		: data?.filter(
				e =>
					(e.roleCode &&
						e.roleCode
							.toLocaleLowerCase()
							.includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase())) ||
					(e.roleName &&
						e.roleName
							.toLocaleLowerCase()
							.includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase())) ||
					(e.roleNameEn &&
						e.roleNameEn
							.toLocaleLowerCase()
							.includes(searchTerm.toLocaleLowerCase().toLocaleLowerCase()))
		  );

export const { setData, setSearchTerm, setDisplayed, setFetchState } = roleSlice.actions;

export default roleSlice.reducer;
